export const REJECTION_REASONS = {
    JOB_TITLE: 'ONLINE_CALIBRATION_REJECTION_REASON_JOB_TITLE',
    SKILLS: 'ONLINE_CALIBRATION_REJECTION_REASON_SKILLS',
    EMPLOYER: 'ONLINE_CALIBRATION_REJECTION_REASON_EMPLOYER',
    INDUSTRY: 'ONLINE_CALIBRATION_REJECTION_REASON_INDUSTRY',
    LOCATION: 'ONLINE_CALIBRATION_REJECTION_REASON_LOCATION',
    RELEVANT_EXPERIENCE: 'ONLINE_CALIBRATION_REJECTION_REASON_RELEVANT_EXPERIENCE',
    SENIORITY: 'ONLINE_CALIBRATION_REJECTION_REASON_SENIORITY',
    EDUCATION: 'ONLINE_CALIBRATION_REJECTION_REASON_EDUCATION',
    LACK_OF_INFORMATION: 'ONLINE_CALIBRATION_REJECTION_REASON_LACK_OF_INFORMATION',
    LANGUAGES: 'ONLINE_CALIBRATION_REJECTION_REASON_LANGUAGES',
    OTHER: 'ONLINE_CALIBRATION_REJECTION_REASON_OTHER',
    ALREADY_REVIEWED: 'ONLINE_CALIBRATION_REJECTION_REASON_ALREADY_REVIEWED',
    PREVIOUS_JOB_TITLES: 'ONLINE_CALIBRATION_REJECTION_PREVIOUS_JOB_TITLES',
    MANAGERIAL_EXPERIENCE: 'ONLINE_CALIBRATION_REJECTION_MANAGERIAL_EXPERIENCE',
    AVERAGE_TENURE: 'ONLINE_CALIBRATION_REJECTION_AVERAGE_TENURE',
    COMPANY_SIZE: 'ONLINE_CALIBRATION_REJECTION_COMPANY_SIZE',
    SCHOOLS: 'ONLINE_CALIBRATION_REJECTION_SCHOOLS',
};

export const REJECTION_REASONS_FEEDBACK = {
    JOB_TITLE: 'FEEDBACK_ON_CANDIDATE_REJECTION_REASON_JOB_TITLE',
    SKILLS: 'FEEDBACK_ON_CANDIDATE_REJECTION_REASON_SKILLS',
    EMPLOYER: 'FEEDBACK_ON_CANDIDATE_REJECTION_REASON_EMPLOYER',
    INDUSTRY: 'FEEDBACK_ON_CANDIDATE_REJECTION_REASON_INDUSTRY',
    LOCATION: 'FEEDBACK_ON_CANDIDATE_REJECTION_REASON_LOCATION',
    RELEVANT_EXPERIENCE: 'FEEDBACK_ON_CANDIDATE_REJECTION_REASON_RELEVANT_EXPERIENCE',
    SENIORITY: 'FEEDBACK_ON_CANDIDATE_REJECTION_REASON_SENIORITY',
    EDUCATION: 'FEEDBACK_ON_CANDIDATE_REJECTION_REASON_EDUCATION',
    LACK_OF_INFORMATION: 'FEEDBACK_ON_CANDIDATE_REJECTION_REASON_LACK_OF_INFORMATION',
    LANGUAGES: 'FEEDBACK_ON_CANDIDATE_REJECTION_REASON_LANGUAGES',
    OTHER: 'FEEDBACK_ON_CANDIDATE_REJECTION_REASON_OTHER',
    ALREADY_REVIEWED: 'FEEDBACK_ON_CANDIDATE_REJECTION_REASON_ALREADY_REVIEWED',
    PREVIOUS_JOB_TITLES: 'FEEDBACK_ON_CANDIDATE_REJECTION_REASON_PREVIOUS_JOB_TITLES',
    MANAGERIAL_EXPERIENCE: 'FEEDBACK_ON_CANDIDATE_REJECTION_REASON_MANAGERIAL_EXPERIENCE',
    AVERAGE_TENURE: 'FEEDBACK_ON_CANDIDATE_REJECTION_REASON_AVERAGE_TENURE',
    COMPANY_SIZE: 'FEEDBACK_ON_CANDIDATE_REJECTION_REASON_COMPANY_SIZE',
    SCHOOLS: 'FEEDBACK_ON_CANDIDATE_REJECTION_REASON_SCHOOLS',
};
